import { Component, computed, inject, signal } from '@angular/core';
import { MatButton } from '@angular/material/button';
import { MatDialogRef } from '@angular/material/dialog';
import { MatIcon } from '@angular/material/icon';
import { MatRadioButton, MatRadioGroup } from '@angular/material/radio';
import { Store } from '@ngrx/store';
import { ModalComponent } from '@src/suite/common/components/modal/modal/modal';
import { TopicDeletionMode } from '@src/suite/common/enums/enums';
import { selectI18N } from '@src/suite/common/store/i18n/selectors/i18n.selectors';

@Component({
    selector: 'st-delete-topic-stories',
    imports: [MatButton, MatIcon, MatRadioButton, MatRadioGroup],
    templateUrl: './st-delete-topic-stories.component.html',
    styleUrl: './st-delete-topic-stories.component.scss',
})
export class DeleteTopicStoriesComponent {
    //injectables
    store = inject(Store);
    dialogRef = inject(MatDialogRef<ModalComponent>);

    //store signals
    languageSettings = this.store.selectSignal(selectI18N);

    //variables
    TopicDeletionMode = TopicDeletionMode;

    //signals
    readonly deletionMode = signal<TopicDeletionMode>(TopicDeletionMode.SAVE_STORIES);

    //computeds
    readonly text = computed(() => {
        return (
            this.languageSettings().PSTWebConfirmDeletePart1 +
            this.languageSettings().PSTObjectTypeTopic +
            '?' +
            ' \n ' +
            this.languageSettings().PSTWebDeleteTopicStoriesDescription1 +
            ' \n ' +
            this.languageSettings().PSTWebDeleteTopicStoriesDescription2
        );
    });

    cancel() {
        this.dialogRef.close();
    }

    deletion() {
        this.dialogRef.close(this.deletionMode());
    }
}
